/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderParticipant } from './LadderParticipant';
import {
    LadderParticipantFromJSON,
    LadderParticipantFromJSONTyped,
    LadderParticipantToJSON,
    LadderParticipantToJSONTyped,
} from './LadderParticipant';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface GetLadderParticipantsResponse
 */
export interface GetLadderParticipantsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetLadderParticipantsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<LadderParticipant>}
     * @memberof GetLadderParticipantsResponse
     */
    participants: Array<LadderParticipant>;
}

/**
 * Check if a given object implements the GetLadderParticipantsResponse interface.
 */
export function instanceOfGetLadderParticipantsResponse(value: object): value is GetLadderParticipantsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    return true;
}

export function GetLadderParticipantsResponseFromJSON(json: any): GetLadderParticipantsResponse {
    return GetLadderParticipantsResponseFromJSONTyped(json, false);
}

export function GetLadderParticipantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLadderParticipantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'participants': ((json['participants'] as Array<any>).map(LadderParticipantFromJSON)),
    };
}

export function GetLadderParticipantsResponseToJSON(json: any): GetLadderParticipantsResponse {
    return GetLadderParticipantsResponseToJSONTyped(json, false);
}

export function GetLadderParticipantsResponseToJSONTyped(value?: GetLadderParticipantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'participants': ((value['participants'] as Array<any>).map(LadderParticipantToJSON)),
    };
}

